<template>
  <section class="closefriend-hero ">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <div class="mx-auto mb-3 px-1">
            <global-message></global-message>

            <!-- Header with Add Option Button -->
            <div class="d-flex align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
              <div class="pe-2">
                <h5 class="text-white font-weight-700 mb-0 font-size-20">Custom Requests</h5>
                <span class="text-muted font-size-12">{{ customRequestOptions.length }} options active</span>
              </div>
              <button type="button" class="cp-btn-primary d-inline-flex align-items-center flex-shrink-0" @click="addCustomRequestOption()">
                <i class="fa fa-plus me-1 font-size-12"></i> Add Option
              </button>
            </div>

            <!-- New Subscribers Banner if exists -->
            <div class="mb-3" v-if="isNeedToAddExists">
              <div class="gradient-a border-radius-10 w-100">
                <div class="bg-animation d-flex p-3 px-3 align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <img class="img-fluid me-2" src="@/assets/images/stella/dash-side-icon.svg">
                    <span class="text-dark font-weight-800 font-size-16">You have new subscribers</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img class="img-fluid ms-1 cursor-pointer" src="@/assets/images/stella/arrow-simple-right-black.svg"
                         @click="goToNewSubscription()">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div v-if="customRequestOptions.length === 0 && !isLoading" class="text-center py-5">
            <div class="mb-4 d-flex justify-content-center">
              <div class="add-card-circle-icon cursor-pointer" style="width: 64px; height: 64px;" @click="addCustomRequestOption()">
                <i class="fa fa-plus text-white font-size-24"></i>
              </div>
            </div>
            <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.85;">No custom options yet</h5>
            <p class="text-muted font-size-14 mb-4" style="max-width: 380px; margin: 0 auto;">
              Create custom perks, shoutouts, or special requests for your fans to order.
            </p>
            <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="addCustomRequestOption()">
              <i class="fa fa-plus me-2 font-size-12"></i> Create First Option
            </button>
          </div>

          <!-- Options Grid + Circular Add Slot -->
          <div v-else class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-3"
                 v-for="(option, index) in customRequestOptions" :key="index">
              <div class="custom-card-transparent" @click="editCustomRequestOption(option)">
                <div class="stella-card-header d-flex align-items-center justify-content-between mb-3">
                  <span class="stella-card-index font-size-12 text-muted font-weight-bold">#{{ index + 1 }}</span>
                  <span class="stella-card-price" style="font-weight: 800; font-size: 18px; color: #fff; background: linear-gradient(135deg, #F3DA6B, #E53BB9); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">${{ option.price }}</span>
                </div>
                <div class="stella-card-body my-auto py-2">
                  <h6 class="stella-card-title text-white font-weight-600 font-size-15 mb-0" style="line-height: 1.4;">{{ option.title }}</h6>
                </div>
                <div class="stella-card-footer d-flex align-items-center justify-content-between pt-3 mt-3 border-top border-white-10">
                  <span class="stella-card-status font-size-12" style="color: #55EFC4;">
                    <span class="status-dot d-inline-block me-1" style="width: 6px; height: 6px; border-radius: 50%; background: #55EFC4;"></span> Active
                  </span>
                  <div class="d-flex align-items-center" style="gap: 12px;">
                    <i class="fa fa-pencil text-white-50 cursor-pointer font-size-14" @click.stop="editCustomRequestOption(option)" title="Edit"></i>
                    <i class="fa fa-trash text-danger cursor-pointer font-size-14 opacity-75" @click.stop="deleteCustomRequestOption(option)" title="Delete"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add New Option Slot -->
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <div class="custom-card-add-slot d-flex flex-column align-items-center justify-content-center cursor-pointer text-center p-4 h-100"
                   @click="addCustomRequestOption()">
                <div class="add-card-circle-icon mb-3">
                  <i class="fa fa-plus text-white font-size-20"></i>
                </div>
                <span class="text-white font-weight-600 font-size-15 mb-1">Add New Option</span>
                <span class="text-muted font-size-12">Custom perk or service</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <model-confirm-delete ref="confirmDeleteOption"
                          id="model_confirm_delete_option"
                          title="Delete Custom Request Option"
                          text="Are you sure you want to delete this custom request option? This action cannot be undone."
                          confirm-btn-txt="Delete"
                          button-color="btn-danger"
                          @confirm="executeDeleteOption()"/>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {constructCustomerURL} from "@/common/baseURL-service";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import titleMixin from "../../../../mixin/title-mixin";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import ModelConfirmDelete from "@/components/module/shared/ModelBasic";

export default {
  name: 'CustomRequestOptionList',
  title: 'Custom request options',
  mixins: [newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu,
    GlobalMessage,
    PwaActionBar,
    ModelConfirmDelete
  },
  data() {
    return {
      user: [],
      customRequestOptions: [],
      optionToDelete: null,
      showSlideBar: false
    }
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    }
  },
  created() {

    if (this.$route.query.saved) {
      this.setMessage('SAVED.SUCCESSFULLY');
    } else if (this.$route.query.deleted) {
      this.setMessage('DELETED.SUCCESSFULLY');
    }

    this.user = this.getUser();
    this.loadCustomRequestOptions();
    this.checkNewSubscription(this.user.id);

  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setMessage']),
    constructCustomerURL,
    addCustomRequestOption() {
      this.$router.replace({name: 'CustomRequestOptionCreate'});
    },
    loadCustomRequestOptions() {
      // /api/v1/influencers/{influencerId}/custom-request-options/
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/`;
      this.getData(url, (customRequestOptions) => {
        this.customRequestOptions = customRequestOptions;
      });
    },
    editCustomRequestOption(customRequest) {
      this.$router.replace({name: 'CustomRequestOptionCreate', params: {customRequestOptionId: customRequest.id}})
    },
    deleteCustomRequestOption(customRequest) {
      this.optionToDelete = customRequest;
      this.$refs.confirmDeleteOption.show();
    },
    executeDeleteOption() {
      if (this.optionToDelete) {
        let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/${this.optionToDelete.id}`;
        this.getDelete(url, () => {
          this.$refs.confirmDeleteOption.hide();
          this.optionToDelete = null;
          this.$store.dispatch('setMessage', 'Custom request option deleted.');
          this.loadCustomRequestOptions();
        });
      }
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    }
  }
}
;
</script>

<style scoped>
.closefriend-hero {
  background-color: #111111 !important;
  background-image: none !important;
  min-height: 100vh;
  border-bottom: none !important;
}
.container-fluid, .row, .col-12 {
  background-color: transparent !important;
  background-image: none !important;
}

.border-white-10 {
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.custom-card-transparent {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 20px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.custom-card-transparent:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(229, 59, 185, 0.35);
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
}

.custom-card-add-slot {
  min-height: 180px;
  border-radius: 20px;
  border: 2px dashed rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.custom-card-add-slot:hover {
  border-color: #E53BB9;
  background: rgba(229, 59, 185, 0.05);
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(229, 59, 185, 0.15);
}

.add-card-circle-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(229, 59, 185, 0.4);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.custom-card-add-slot:hover .add-card-circle-icon,
.add-card-circle-icon:hover {
  transform: scale(1.12) rotate(90deg);
}
</style>
